/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Link_ActionInputs */

const fr_guardian_link_action = /** @type {(inputs: Guardian_Link_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lier`)
};

/**

* @param {Guardian_Link_ActionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_link_action = /** @type {((inputs?: Guardian_Link_ActionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Link_ActionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_link_action(inputs)
});